(() => {
  if (window.popNavigationHoverInstalled) return;
  window.popNavigationHoverInstalled = true;
  const desktop = window.matchMedia('(min-width: 990px) and (any-hover: hover) and (any-pointer: fine)');
  const openTimers = new WeakMap();
  const closeTimers = new WeakMap();
  const selector = '.pop-nav-enabled .header__inline-menu header-menu';
  const floatingSelector = '.pop-nav-enabled .pop-nav-floating';
  const accordionSelector = '.pop-nav-enabled .pop-shop-all__accordion';
  // Keep floating panels beneath the header, anchored to their trigger and inside the viewport.
  const positionFloating = (details) => {
    if (window.innerWidth < 990 || !details.open) return;
    const panel = details.querySelector('.pop-nav-floating__panel');
    const summary = details.querySelector('summary');
    const wrapper = details.closest('.header-wrapper');
    if (!panel || !summary || !wrapper) return;
    const parent = panel.offsetParent;
    if (!parent) return;
    const parentRect = parent.getBoundingClientRect();
    const headerRect = wrapper.getBoundingClientRect();
    const triggerRect = summary.getBoundingClientRect();
    const panelWidth = panel.getBoundingClientRect().width;
    const viewportWidth = document.documentElement.clientWidth;
    const anchorInset = details.classList.contains('pop-shop-all') ? 24 : 16;
    const left = Math.max(16, Math.min(triggerRect.left - anchorInset, viewportWidth - panelWidth - 16));
    panel.style.left = `${left - parentRect.left - parent.clientLeft + parent.scrollLeft}px`;
    panel.style.top = `${headerRect.bottom - 1 - parentRect.top - parent.clientTop + parent.scrollTop}px`;
    panel.style.maxHeight = `${Math.max(0, window.innerHeight - headerRect.bottom - 24)}px`;
  };
  // Native click and keyboard opening also use the same positioning as mouse hover.
  document.addEventListener('toggle', (event) => {
    if (event.target.matches?.(floatingSelector)) positionFloating(event.target);
  }, true);
  let geometryFrame;
  const refreshGeometry = () => {
    if (geometryFrame) return;
    geometryFrame = requestAnimationFrame(() => {
      geometryFrame = undefined;
      document.querySelectorAll(`${floatingSelector}[open]`).forEach(positionFloating);
    });
  };
  window.addEventListener('resize', refreshGeometry, { passive: true });
  window.addEventListener('scroll', refreshGeometry, { passive: true });
  document.addEventListener('shopify:section:load', refreshGeometry);
  // Handle inline groups before Dawn's drawer summary listeners can open a slide-out submenu.
  document.addEventListener('click', (event) => {
    const summary = event.target.closest?.(`${accordionSelector} > summary`);
    if (!summary) return;
    event.preventDefault();
    event.stopPropagation();
    const details = summary.parentElement;
    details.open = !details.open;
    summary.setAttribute('aria-expanded', String(details.open));
  }, true);
  document.addEventListener('toggle', (event) => {
    if (!event.target.matches?.(accordionSelector)) return;
    event.target.querySelector('summary')?.setAttribute('aria-expanded', String(event.target.open));
  }, true);
  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest?.(`${accordionSelector}[open]`);
    if (!details) return;
    event.preventDefault();
    event.stopPropagation();
    details.open = false;
    const summary = details.querySelector('summary');
    summary?.setAttribute('aria-expanded', 'false');
    summary?.focus();
  }, true);
  const cancel = (menu) => {
    clearTimeout(openTimers.get(menu));
    clearTimeout(closeTimers.get(menu));
  };
  const toggle = (menu, open) => {
    const details = menu.querySelector('details');
    if (!details) return;
    details.open = open;
    details.querySelector('summary')?.setAttribute('aria-expanded', String(open));
    const wrapper = menu.closest('.header-wrapper');
    if (wrapper) {
      wrapper.style.setProperty('--pop-header-bottom', `${Math.max(0, wrapper.getBoundingClientRect().bottom)}px`);
    }
    if (open && details.matches(floatingSelector)) positionFloating(details);
  };
  document.addEventListener('pointerover', (event) => {
    if (!desktop.matches || event.pointerType !== 'mouse') return;
    const menu = event.target.closest(selector);
    if (!menu) return;
    // Crossing between text, SVG and panel must not cancel a pending open.
    clearTimeout(closeTimers.get(menu));
    if (event.relatedTarget && menu.contains(event.relatedTarget)) return;
    clearTimeout(openTimers.get(menu));
    openTimers.set(menu, setTimeout(() => {
      if (!menu.isConnected || !desktop.matches) return;
      document.querySelectorAll(selector).forEach((other) => {
        if (other !== menu) { cancel(other); toggle(other, false); }
      });
      toggle(menu, true);
    }, 100));
  });
  document.addEventListener('pointerout', (event) => {
    if (!desktop.matches || event.pointerType !== 'mouse') return;
    const menu = event.target.closest(selector);
    if (!menu || (event.relatedTarget && menu.contains(event.relatedTarget))) return;
    cancel(menu);
    closeTimers.set(menu, setTimeout(() => {
      if (!menu.contains(document.activeElement)) toggle(menu, false);
    }, 220));
  });
  document.addEventListener('keydown', (event) => {
    // Recompute visible drawer controls as accordions open/close; keep Tab inside Shop All.
    const panel = event.target?.closest?.('.pop-nav-enabled .pop-shop-all__mobile-panel');
    if (panel && event.key === 'Tab') {
      const controls = [...panel.querySelectorAll('summary, a[href], button:enabled, [tabindex="0"]')]
        .filter((element) => element.getClientRects().length > 0);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (first && ((event.shiftKey && event.target === first) || (!event.shiftKey && event.target === last))) {
        event.preventDefault();
        event.stopPropagation();
        (event.shiftKey ? last : first).focus();
      }
    }
    if (event.key !== 'Escape') return;
    document.querySelectorAll(selector).forEach((menu) => {
      cancel(menu);
      if (menu.querySelector('details')?.open) {
        if (menu.contains(document.activeElement)) menu.querySelector('summary')?.focus();
        toggle(menu, false);
      }
    });
  }, true);
  desktop.addEventListener('change', () => {
    document.querySelectorAll(selector).forEach((menu) => {
      cancel(menu); toggle(menu, false);
    });
  });
})();
